// Unpublished Work © 2020-2022 Deere & Company

import React from 'react';
import {oktaAuth} from '../../../factories/okta-config-factory';
import {DefaultError} from './default-error';
import {OktaAuthError} from './okta-auth-error';
import PropTypes from 'prop-types';

export const PageError = (props) => {
    if (oktaAuth.getAccessToken() === undefined) {
        return <OktaAuthError/>;
    }

    return <DefaultError message={props.message}/>;
};

PageError.propTypes = {
    message: PropTypes.string
};
